import { Box, Text, useToast } from '@chakra-ui/react';
import { format, getTime, setHours, setMinutes } from 'date-fns';
import { useContext, useEffect, useRef, useState } from 'react';
import {
  AiOutlineClockCircle,
  AiOutlineMail,
  AiOutlineWhatsApp
} from 'react-icons/ai';
import { BsArrowDownCircle } from 'react-icons/bs';
import { CiCalendar } from 'react-icons/ci';
import {
  IoIosInformationCircleOutline,
  IoMdInformationCircleOutline
} from 'react-icons/io';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';

import checkIcon from '../../../../../assets/svgs/check-icon.svg';
import chevronRightIcon from '../../../../../assets/svgs/chevron_right_circle-icon.svg';
import idIcon from '../../../../../assets/svgs/id-icon.svg';
import { DatePickerExport } from '../../../../../components/datepicker/DatePickerExport';
import { CustomIcon } from '../../../../../components/widgets/CustomIcon';
import { Spinner } from '../../../../../components/widgets/Spinner';
import { TooltipComponent } from '../../../../../components/widgets/Tooltip';
import VisualizationContext from '../../../../../contexts/VisualizationContext';
import { apiSensedia } from '../../../../../services/api-sensedia';
import { getDadosLogin } from '../../../../../utils/dados-login.util';
import { getProductName } from '../../../../../utils/leads.util';
import { getTelephoneOrCellPhoneNumber } from '../../gestao/utils/getTelephoneOrCellPhoneNumber';
import StatusDetailsConcluido from './StatusDetailsConcluido';
import StatusDetailsNegociacao from './StatusDetailsNegociacao';

const LeadDetails = () => {
  const [history, setHistory] = useState<any>([
    { last_modification: '15/01/1992 00:01' },
    { last_modification: '15/01/1992 00:01' }
  ]);
  const { setVisualizationState } = useContext(VisualizationContext);
  const { idLead } = useParams();
  const { state }: any = useLocation();
  const [historyLoading, setHistoryLoading] = useState(false);

  const [startDate, setStartDate] = useState<any>(null);
  const [sellers, setSellers] = useState(null);
  const [anotacoes, setAnotacoes] = useState('');
  const [percepcao, setPercepcao] = useState('');
  const [novoVendedor, setNovoVendedor] = useState('');

  const toast = useToast();
  const navigate = useNavigate();
  const [time, setTime] = useState('00:00');
  const [conclusionInfo, setConclusionInfo] = useState({
    query: {
      plan_saude: null,
      plan_odonto: null,
      plan_vida: null,
      products: null,
      type: null,
      sem_sucesso: null
    }
  });
  const mobileRef = useRef(0);
  const [emNegociacaoInfo, setEmNegociacaoInfo] = useState(null);
  const [tentativas, setTentativas] = useState('');
  const [validateUser, setValidateUser] = useState(false);
  const [actualStatus, setActualStatus] = useState('');
  const [validateSave, setValidateSave] = useState(true);
  const [newStatus, setNewStatus] = useState('');
  const [loadingSaveDetails, setLoadingSaveDetails] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openDatePicker, setOpenDatePicker] = useState(false);
  const [endDate, setEndDate] = useState(null);
  const [isManager, setIsManager] = useState(false);
  const [changeSuccessful, setChangeSuccessful] = useState(false);
  const [sellersList, setSellersList] = useState([]);

  const [details, setDetails] = useState({
    DATA_ULTIMA_VISUALIZACAO__c: null,
    EMAIL__c: '',
    DATA_SOLICITACAO_CONTATO__c: null,
    ABORDAGEM_N3__c: null,
    EventUuid: '',
    _EventType: '',
    ESTRUTURA_APOIO__c: null,
    OBJETIVO_CAMPANHA__c: '',
    NOME_CORRETOR__c: '',
    CreatedById: '',
    ACAO_APOIO__c: null,
    NOME__c: '',
    PDN_LEADUPDATE__c: '',
    CODIGO_PRODUTOR__c: '',
    ID_MDM__c: '',
    PAPEL__c: '',
    SOLICITOU_CONTATO__c: null,
    TELEFONE__c: null,
    EXPORTADO_CSV__c: null,
    _ObjectType: '',
    STATUS__c: 'Novas Oportunidades',
    DATA_CAMPANHA__c: '',
    ABORDAGEM_N2__c: null,
    RATING__c: null,
    LOTE__c: '',
    PDN_NomeEstipulante__c: null,
    DESCRITIVO_CAMPANHA__c: '',
    ABORDAGEM__c: null,
    CELULAR__c: '',
    Campanha__c: '',
    ESTRUTURA_VENDA__c: '',
    ReplayId: '',
    CPF__c: null,
    CreatedDate: 0,
    ID_LEAD__c: '',
    PDN_ProdutoAtual__c: null,
    INSCRICAO__c: null,
    DATA_ULTIMA_ALTERACAO__c: null,
    LOGIN__c: '',
    NOME_ESTIPULANTE__c: '',
    PRODUTO_ATUAL__c: '',
    SEGMENTO__c: '',
    nome_coluna: '',
    cor_coluna: '',
    DATA_AGENDAMENTO__c: { _seconds: 0 },
    PERCEPCAO__c: '',
    CNPJ__c: '',
    MENSAGEM__c: '',
    TENTATIVAS_CONTATO__c: '',
    QuantidadeVida__c: null,
    QuantidadeSegurados__c: null,
    PROFISSAO__c: '',
    DataNascimento__c: null
  });

  const formatType = (type) => {
    switch (type) {
      case 'venda-realizada':
        return true;
      case 'venda-nao-realizada':
        return false;
      default:
        return null;
    }
  };

  const formatTypeVenda = (abordagem) => {
    switch (abordagem) {
      case true:
        return 'venda-realizada';
      case false:
        return 'venda-nao-realizada';
      default:
        return null;
    }
  };

  const formatDate = (date) => {
    const splitTime = time.split(':');
    const formatedHours = setHours(date, +splitTime[0]);
    const formatedMinutes = setMinutes(formatedHours, +splitTime[1]);
    const toTimestamp = getTime(formatedMinutes);

    return toTimestamp;
  };

  const formatAbordagem = () => {
    switch (newStatus) {
      case 'Concluido':
        return conclusionInfo.query.sem_sucesso;
      case 'EmNegociacao':
        return emNegociacaoInfo;
      default:
        return null;
    }
  };

  const formatBody = () => {
    let formatQuery: any = {
      status: newStatus ? newStatus : null
    };

    if (newStatus === 'Concluido') {
      const validatePlans = {
        plan_saude: conclusionInfo.query.plan_saude
          ? conclusionInfo.query.plan_saude
          : null,
        plan_odonto: conclusionInfo.query.plan_odonto
          ? conclusionInfo.query.plan_odonto
          : null,
        plan_vida: conclusionInfo.query.plan_vida
          ? conclusionInfo.query.plan_vida
          : null
      };

      for (const filter in validatePlans) {
        if (validatePlans[filter] === null || validatePlans[filter] === '') {
          delete validatePlans[filter];
        }
      }
      formatQuery = {
        ...formatQuery,
        ...formatQuery.query,
        abordagem: formatType(conclusionInfo.query.type),
        abordagem_n2: conclusionInfo.query.sem_sucesso
          ? conclusionInfo.query.sem_sucesso
          : null,
        produtos: conclusionInfo.query.products
          ? conclusionInfo.query.products
          : null,
        planos:
          Object.keys(validatePlans).length > 0
            ? Object.values(validatePlans)
            : null
      };
    }
    if (newStatus !== 'Novas Oportunidades') {
      formatQuery = {
        ...formatQuery,
        tentativas: tentativas ? tentativas : null,
        abordagem_n2: formatAbordagem(),
        data_agendamento: startDate ? formatDate(startDate) : null,
        percepcao: percepcao ? percepcao : null,
        anotacoes: anotacoes ? anotacoes : null,
        novo_vendedor: novoVendedor ? novoVendedor : null
      };
    } else {
      formatQuery = {
        ...formatQuery,
        abordagem: null,
        abordagem_n2: null,
        percepcao: percepcao ? percepcao : null,
        anotacoes: anotacoes ? anotacoes : null,
        lead_reaberto: actualStatus === 'Concluido' ? true : null
      };
      return formatQuery;
    }

    for (const filter in formatQuery) {
      if (formatQuery[filter] === null || formatQuery[filter] === '') {
        delete formatQuery[filter];
      }
    }
    return formatQuery;
  };

  const saveLeadDetail = async () => {
    const validateInputs = validateCanSave();
    setValidateSave(validateInputs);

    if (validateInputs === false) return;

    try {
      setLoadingSaveDetails(true);
      const body = formatBody();
      await apiSensedia.put(
        `oportunidades-sulamerica/painel-leads/leads/` + idLead,
        { ...body }
      );
      toast({
        position: 'top',
        description:
          'As alterações foram salvas com sucesso. Aguarde 3 segundos para ser redirecionado',
        status: 'success',
        duration: 4000,
        isClosable: true
      });
      setLoadingSaveDetails(false);
      setTimeout(() => navigate('/corretor/leads/kanban'), 3000);
    } catch (e: any) {
      const errorObj = e?.toJSON();
      toast({
        position: 'top',
        description: (
          <Box>
            <Text>
              {' '}
              Ocorreu um erro. Esvazie o cache do navegador, aguarde alguns
              minutos e tente fazer login novamente, se persistir, por favor
              entrar em contato.
            </Text>
            <Text>
              {errorObj?.status && (
                <>
                  <br />
                  <b>Detalhes:</b>
                  <br />
                </>
              )}
              {(errorObj?.status || e?.response?.data?.statusCode) && (
                <>{errorObj.status ?? e.response.data.statusCode}</>
              )}
              {errorObj?.status &&
                (e?.response?.data?.message || errorObj?.message) &&
                ' - '}
              {(e?.response?.data?.message || errorObj?.message) && (
                <>{e.response.data.message ?? errorObj.message}</>
              )}
            </Text>
          </Box>
        ),
        duration: 15000,
        isClosable: true,
        status: 'error'
      });
      setLoadingSaveDetails(false);
      console.log(e);
    }
  };

  const showStatus = () => {
    switch (true) {
      case actualStatus === 'Novas Oportunidades':
        return [
          { nome: 'Novas Oportunidades', id: 'Novas Oportunidades' },
          { nome: 'Agendado', id: 'NovoContato' },
          { nome: 'Em Negociação', id: 'EmNegociacao' },
          { nome: 'Concluído', id: 'Concluido' }
        ];
      case actualStatus === 'NovoContato':
        return [
          { nome: 'Agendado', id: 'NovoContato' },
          { nome: 'Em Negociação', id: 'EmNegociacao' },
          { nome: 'Concluído', id: 'Concluido' }
        ];
      case actualStatus === 'EmNegociacao':
        return [
          { nome: 'Em Negociação', id: 'EmNegociacao' },
          { nome: 'Concluído', id: 'Concluido' }
        ];
      case actualStatus === 'Concluido' && details?.ABORDAGEM__c === false:
        return [
          { nome: 'Concluído', id: 'Concluido' },
          { nome: 'Novas Oportunidades', id: 'Novas Oportunidades' }
        ];
      case actualStatus === 'Concluido' && details?.ABORDAGEM__c === true:
        return [{ nome: 'Concluído', id: 'Concluido' }];
      default:
        return [''];
    }
  };

  const formatStatus = (status: string) => {
    switch (status) {
      case 'Novas Oportunidades':
        return 'Novas Oportunidades';
      case 'NovoContato':
        return 'Agendado';
      case 'EmNegociacao':
        return 'Em Negociação';
      case 'Concluido':
        return 'Concluído';
      default:
        return '';
    }
  };

  const formatCel = (status: string) => {
    let formating = String(status)
      .replace(/\D/g, '')
      .replace(/[^a-zA-Z0-9 ]/g, '');

    formating = formating.replace(/^0/, '');
    if (formating.length >= 12) {
      formating = formating.slice(2);
    }
    return formating;
  };

  const getHistoryData = async () => {
    setHistoryLoading(true);

    const headers =
      state?.isGestor === true ? { params: { 'tipo-consulta': 'gestao' } } : {};
    try {
      const { data } = await apiSensedia.get(
        `oportunidades-sulamerica/painel-leads/leads/${idLead}/logs`,
        {
          ...headers,
          timeout: 0
        }
      );

      setHistory(data);
      setHistoryLoading(false);
    } catch (error: any) {
      if (
        error.response.data.data.error_message ===
        'Lead não pertence ao usuário'
      ) {
        setHistory([]);
        setHistoryLoading(false);
      }
      setHistory([]);
      setHistoryLoading(false);
    }
  };

  const getData = async () => {
    try {
      setLoading(true);
      const { data } = await apiSensedia.get(
        `oportunidades-sulamerica/painel-leads/leads/` + idLead
      );
      setStartDate(data.DATA_AGENDAMENTO__c?._seconds * 1000 || null);

      setAnotacoes(data.ANOTACOES__c);
      setTentativas(data.TENTATIVAS__c);
      setTime('00:00');
      if (data.STATUS__c === 'EmNegociacao') {
        setEmNegociacaoInfo(data.ABORDAGEM_N2__c || null);
      }
      if (data.STATUS__c === 'Concluido') {
        const newQuery = {
          query: {
            ...conclusionInfo.query,
            products: data.PRODUTOS__c,
            type: formatTypeVenda(data.ABORDAGEM__c),
            sem_sucesso: data.ABORDAGEM_N2__c || null
          }
        };
        setConclusionInfo({ ...newQuery });
      }
      setNewStatus(data.STATUS__c);
      setActualStatus(data.STATUS__c);
      setPercepcao(data.PERCEPCAO__c);
      setDetails(data);
      setLoading(false);
    } catch (error: any) {
      const errorObj = error?.toJSON();
      toast({
        position: 'top',
        description: (
          <Box>
            <Text>
              {' '}
              Ocorreu um erro. Esvazie o cache do navegador, aguarde alguns
              minutos e tente fazer login novamente, se persistir, por favor
              entrar em contato.
            </Text>
            <Text>
              {errorObj?.status && (
                <>
                  <br />
                  <b>Detalhes:</b>
                  <br />
                </>
              )}
              {(errorObj?.status || error?.response?.data?.statusCode) && (
                <>{errorObj.status ?? error.response.data.statusCode}</>
              )}
              {errorObj?.status &&
                (error?.response?.data?.message || errorObj?.message) &&
                ' - '}
              {(error?.response?.data?.message || errorObj?.message) && (
                <>{error.response.data.message ?? errorObj.message}</>
              )}
            </Text>
          </Box>
        ),
        duration: 15000,
        isClosable: true,
        status: 'error'
      });
      console.log(error);
    }
  };

  const getTypeUser = async () => {
    setLoading(true);

    try {
      const dadosLogin = await getDadosLogin();

      if (dadosLogin?.isManager === true) await getPerfis();
    } catch (error: any) {
      setLoading(false);
    }
  };

  const validateCanSave = () => {
    if (newStatus === 'Novas Oportunidades' && actualStatus === 'Concluido') {
      return true;
    }
    if (
      newStatus === 'NovoContato' &&
      startDate !== null &&
      tentativas !== ''
    ) {
      return true;
    }

    if (newStatus === 'EmNegociacao' && emNegociacaoInfo !== null) {
      return true;
    }

    if (newStatus === 'Concluido') {
      const productsPlan = {
        Saúde: 'plan_saude',
        Odonto: 'plan_odonto',
        Vida: 'plan_vida'
      };
      let validatePlan = true;

      const validProductsPlan = conclusionInfo.query.products?.filter(
        (product) => {
          return (
            product === 'Saúde' || product === 'Odonto' || product === 'Vida'
          );
        }
      );
      validProductsPlan?.forEach((product) => {
        const planKey = productsPlan[product];
        const productPlan = conclusionInfo.query[planKey];

        if (
          productPlan === null ||
          productPlan === undefined ||
          productPlan === ''
        ) {
          validatePlan = false;
        }
      });

      if (
        conclusionInfo.query.type === 'venda-realizada' &&
        validatePlan &&
        conclusionInfo.query.products?.length > 0
      ) {
        return true;
      }
      if (
        conclusionInfo.query.type === 'venda-nao-realizada' &&
        conclusionInfo.query.sem_sucesso !== null
      ) {
        return true;
      }
    }
    return false;
  };

  const getPerfis = async () => {
    try {
      let looping = true;
      while (looping) {
        try {
          const { data } = await apiSensedia.get(
            `/oportunidades-sulamerica/painel-leads/gestao/perfis`,
            {
              timeout: 0
            }
          );
          setSellers(data);
          setSellersList(data);
          looping = false;
        } catch (e: any) {
          if (e.response.status == 500) {
            console.log('ocorreu internal server error', e.response.statusText);
            console.log('ocorreu internal server error', e.response.data);
          } else if (e.response.status == 504) {
            console.log('ocorreu gateway timeout', e.response.data);
          }
          if (e.response.status !== 504) {
            looping = false;
          }
        }
      }
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
    }
  };

  const setReason = (reason: string) => {
    switch (reason) {
      case 'lgpd-bloqueado':
        return 'Bloqueado para contato; (LGPD) cliente diz não ter solicitado contato';
      case 'nao-responde':
        return 'Não responde | sem interação nos contatos realizados';
      case 'dados-invalidos':
        return 'Dados inválidos';
      case 'preco':
        return 'Preço';
      case 'fora-rede':
        return 'Fora da rede credenciada | Fora da área de abrangência | Localização';
      case 'concorrencia':
        return 'Concorrência | Fechou com outra Seguradora | Atendido por outro Corretor';
      case 'cnpj-inativo':
        return 'CNPJ inativo | Emissão de certidão negativa';
      case 'mei-menos':
        return 'MEI menos de 6 meses';
      case 'pj-1-vida':
        return 'PJ para 1 vida';
      case 'ja-contratou':
        return 'Já contratou';
      case 'converteu-saude':
        return 'Interesse em outros produtos | Converteu Saúde';
      case 'converteu-odonto':
        return 'Interesse em outros produtos | Converteu Odonto';
      case 'converteu-vida':
        return 'Interesse em outros produtos | Converteu Vida';
      case 'converteu-viagem':
        return 'Interesse em outros produtos | Converteu Viagem';
      case 'sem-interesse':
        return 'Não teve interesse';
      case 'recusa-sula':
        return 'Recusa SulAmérica DPS';
      case 'transmissao':
        return 'Transmissão realizada';
      case 'cotacao':
        return 'Cotação realizada';
      default:
        return reason;
    }
  };

  const setReasonHistory = (item: any) => {
    switch (true) {
      case item.TIPO_LOG__c === 'Percepção':
        return 'Percepção do contato: ' + item.PERCEPCAO__c;
      case item.TIPO_LOG__c === 'Distribuição':
        return 'Distribuição';
      case item.TIPO_LOG__c === 'Redistribuição':
        return 'Redistribuição';
      case item.TIPO_LOG__c === 'Visualizado':
        return 'Visualizado';
      case item.TIPO_LOG__c === 'Exportação':
        return 'Exportação';
      case item.TIPO_LOG__c === 'Atualizado':
        return 'Atualizado para ' + formatStatus(item.STATUS__c);
      case item.TIPO_LOG__c === 'Atualizado' &&
        item.STATUS__c === 'NovoContato' &&
        item?.DATA_AGENDAMENTO__c:
        return (
          ' -  Agendou contato com lead para: ' +
          new Intl.DateTimeFormat('pt-BR', {
            timeZone: 'UTC'
          }).format(new Date(item?.DATA_AGENDAMENTO__c?._seconds * 1000))
        );
      case item.TIPO_LOG__c === 'Atualizado' &&
        item.STATUS__c === 'EmNegociacao':
        return ' - ' + setReason(item?.ABORDAGEM_N2__c || '');
      case item.TIPO_LOG__c === 'Atualizado' && item.STATUS__c === 'Concluido':
        return !!item.ABORDAGEM__c === true
          ? ' - Venda realizada'
          : ' - Venda não realizada';
      default:
        return item.TIPO_LOG__c;
    }
  };

  const searchSeller = (login: string) => {
    if (login === null) {
      const gestor = sellers?.find((vendedor) => {
        return vendedor.tipo === 'gestor';
      });

      return gestor?.nome || '';
    }
    const seller = sellers?.find((vendedor) => {
      return vendedor.id === login;
    });
    if (seller) {
      return seller.nome;
    }
    return '';
  };

  const handleNovoVendedor = async (value: string) => {
    setNovoVendedor(value);
    setChangeSuccessful(true);

    let body = { novo_vendedor: value };
    const validateFailConclude =
      actualStatus === 'Concluido' && details.ABORDAGEM__c === false;
    const formatQuery = {
      status: 'Novas Oportunidades',
      abordagem: null,
      abordagem_n2: null,
      percepcao: percepcao ? percepcao : null,
      anotacoes: anotacoes ? anotacoes : null,
      lead_reaberto: true
    };

    if (validateFailConclude) {
      body = {
        ...body,
        ...formatQuery
      };
    }
    try {
      await apiSensedia.put(
        `oportunidades-sulamerica/painel-leads/leads/` + idLead,
        { ...body }
      );
      validateFailConclude && navigate('/corretor/leads/kanban');
      await getData();
    } catch (error: any) {
      const errorObj = error?.toJSON();
      toast({
        position: 'top',
        description: (
          <Box>
            <Text>
              {' '}
              Ocorreu um erro. Esvazie o cache do navegador, aguarde alguns
              minutos e tente fazer login novamente, se persistir, por favor
              entrar em contato.
            </Text>
            <Text>
              {errorObj?.status && (
                <>
                  <br />
                  <b>Detalhes:</b>
                  <br />
                </>
              )}
              {(errorObj?.status || error?.response?.data?.statusCode) && (
                <>{errorObj.status ?? error.response.data.statusCode}</>
              )}
              {errorObj?.status &&
                (error?.response?.data?.message || errorObj?.message) &&
                ' - '}
              {(error?.response?.data?.message || errorObj?.message) && (
                <>{error.response.data.message ?? errorObj.message}</>
              )}
            </Text>
          </Box>
        ),
        duration: 15000,
        isClosable: true,
        status: 'error'
      });
      setLoadingSaveDetails(false);

      console.log(error);
    }
  };

  const formatDisplayDate = (dateString: string): string => {
    const dateParts = dateString.split('-');

    if (dateParts.length === 3) {
      const [year, month, day] = dateParts;
      return `${day}/${month}/${year}`;
    }

    return '-';
  };

  useEffect(() => {
    if (state?.isGestor === true) {
      setValidateUser(true);
    }
    window.scrollTo(0, 0);
    getData();
    getTypeUser();
  }, []);

  useEffect(() => {
    if (state?.isGestor === true) {
      setValidateUser(true);
    }
    getHistoryData();
  }, [state]);

  useEffect(() => {
    const manager = sellers?.filter((vendedor) => {
      return vendedor.tipo === 'gestor';
    });
    mobileRef.current = window.innerWidth;
    setIsManager(manager?.length > 0);
  }, [sellers]);

  return (
    <>
      <div className="tw-w-[100%] tw-flex tw-items-center tw-justify-between tw-bg-[#D2D2D2] tw-px-[4rem] tw-py-4">
        <div className="tw-flex tw-flex-col tw-gap-1">
          <p className="tw-font-bold tw-text-[2rem]">
            Detalhes - {formatStatus(details.STATUS__c)}
          </p>
          {isManager && (
            <p>
              Vendedor:{' '}
              <span className="tw-font-bold">
                {searchSeller(details.LOGIN__c)}
              </span>
            </p>
          )}
        </div>

        <button
          onClick={() => navigate(`/corretor/leads/inserir-lead/${idLead}`)}
          className="tw-bg-[#001e64] tw-text-white tw-font-semibold tw-px-6 tw-py-2 tw-rounded-full hover:tw-bg-[#005fa3] tw-transition"
        >
          Criar novo lead
        </button>
      </div>
      <div className="tw-pb-[1rem] tw-flex tw-flex-col tw-items-center tw-w-full tw-justify-center">
        <div className="tw-pb-[1rem] tw-flex tw-flex-col tw-bg-white tw-w-[80%] tw-px-4 tw-mt-4 tw-rounded-lg tw-shadow-xl">
          <div className="tw-border-b-1 tw-border-[#E3E3E3] tw-h-0 tw-my-[1rem] " />
          <div className="tw-flex mb:tw-flex-col mb:tw-w-full sm:tw-flex-row mb:tw-gap-6 sm:tw-gap-0">
            <div className="sm:tw-w-[50%] mb:tw-w-full tw-bg-[#E3E3E3] tw-rounded-md sm:tw-mr-[2%] mb:tw-p-[20px] sm:tw-p-[2vh]">
              <div
                className={`tw-flex tw-flex-col tw-gap-[7px] tw-h-full tw-w-full tw-items-start ${
                  loading && 'tw-items-center'
                }
                }`}
              >
                <p className="tw-font-bold tw-mb-[1vh] tw-text-[1.1rem] tw-text-start tw-w-full">
                  Dados do Cliente
                </p>
                {!loading ? (
                  <div className="tw-full">
                    <div className="tw-flex">
                      <p className="tw-font-bold">Dados de criação:</p>
                      &nbsp;
                      <p>
                        {details.CreatedDate
                          ? format(
                              new Date(details.CreatedDate),
                              "dd/MM/yyyy 'às' HH:mm"
                            )
                          : ' -'}
                      </p>
                    </div>
                    <div className="tw-flex">
                      <p className="tw-font-bold">ID_MDM:</p>
                      &nbsp;
                      <p>{details.ID_MDM__c ? details.ID_MDM__c : ' -'} </p>
                    </div>
                    <div className="tw-text-start">
                      <p>
                        <strong>Nome:</strong>
                        &nbsp;
                        {details.NOME__c ? details.NOME__c : ' -'}
                      </p>
                    </div>
                    <div className="tw-text-start">
                      <p className="">
                        <strong>CPF:</strong>
                        &nbsp;
                        {details.CPF__c
                          ? details.CPF__c?.length === 11
                            ? details.CPF__c.replace(
                                /(\d{3})(\d{3})(\d{3})(\d{2})/,
                                '$1.$2.$3-$4'
                              )
                            : details.CPF__c?.replace(
                                /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
                                '$1 $2 $3/$4-$5'
                              )
                          : ' -'}
                      </p>
                    </div>
                    <div className="tw-flex tw-gap-1">
                      <p className="tw-font-bold">CNPJ:</p>
                      <p>
                        {details.CNPJ__c?.length > 11
                          ? details.CNPJ__c?.replace(
                              /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
                              '$1.$2.$3/$4-$5'
                            )
                          : ' -'}
                      </p>
                    </div>
                    <div className="tw-text-start">
                      <p>
                        <strong>Número de Contato:</strong>
                        &nbsp;
                        {details.TELEFONE__c || details.CELULAR__c
                          ? getTelephoneOrCellPhoneNumber(
                              details.TELEFONE__c,
                              details.CELULAR__c
                            )
                          : ' -'}
                      </p>
                    </div>
                    <div className="tw-flex">
                      <p className="tw-font-bold">E-mail:</p>
                      &nbsp;
                      <p>{details.EMAIL__c ? details.EMAIL__c : ' -'}</p>
                      &nbsp;
                    </div>
                    <div className="tw-text-start">
                      <p>
                        <strong>Segmento:</strong>
                        &nbsp;
                        {details.PDN_ProdutoAtual__c
                          ? getProductName(details.PDN_ProdutoAtual__c)
                          : ' -'}
                      </p>
                    </div>
                    <div className="tw-flex">
                      <p className="tw-font-bold">Quantidade de Vidas:</p>
                      &nbsp;
                      <p>
                        {details.QuantidadeVida__c
                          ? details.QuantidadeVida__c
                          : ' -'}
                      </p>
                      &nbsp;
                    </div>
                    <div className="tw-flex">
                      <p className="tw-font-bold">Quantidade de Segurados:</p>
                      &nbsp;
                      <p>
                        {details.QuantidadeSegurados__c
                          ? details.QuantidadeSegurados__c
                          : ' -'}
                      </p>
                      &nbsp;
                    </div>
                    <div className="tw-flex">
                      <p className="tw-font-bold">Profissão:</p>
                      &nbsp;
                      <p>
                        {details.PROFISSAO__c ? details.PROFISSAO__c : ' -'}
                      </p>
                      &nbsp;
                    </div>
                    <div className="tw-flex">
                      <p className="tw-font-bold">Data de Nascimento:</p>
                      &nbsp;
                      <p>
                        {details.DataNascimento__c
                          ? formatDisplayDate(details.DataNascimento__c)
                          : ' -'}
                      </p>
                      &nbsp;
                    </div>
                  </div>
                ) : (
                  <div className="tw-py-16 tw-flex tw-flex-col tw-h-full tw-items-center tw-justify-center">
                    <Spinner width={10} height={10} />
                  </div>
                )}
              </div>
            </div>
            <div className="sm:tw-w-[50%] mb:tw-w-full tw-flex tw-flex-col tw-justify-between tw-bg-[#E3E3E3] tw-rounded-md mb:tw-p-[20px] sm:tw-p-[2vh]">
              <div
                className={`tw-flex tw-flex-col tw-gap-[7px] tw-h-full tw-w-full tw-items-start ${
                  loading && 'tw-items-center'
                }
                }`}
              >
                <p className="tw-font-bold tw-mb-[1vh] tw-text-[1.1rem] tw-text-start tw-w-full">
                  Dados da Campanha
                </p>
                {!loading ? (
                  <div className="tw-full">
                    <div className="tw-text-start">
                      <p>
                        <strong>Campanha:</strong>
                        &nbsp;
                        {details.Campanha__c ? details.Campanha__c : ' -'}
                      </p>
                    </div>
                    <div className="tw-text-start">
                      <p>
                        <strong>Lote:</strong>
                        &nbsp;
                        {details.LOTE__c ? details.LOTE__c : ' -'}
                      </p>
                    </div>
                    <div className="tw-text-start">
                      <p>
                        <strong>Data campanha:</strong>
                        &nbsp;
                        {details.DATA_CAMPANHA__c
                          ? details.DATA_CAMPANHA__c
                          : ' -'}
                      </p>
                    </div>
                    <div className="tw-text-start">
                      <p>
                        <strong>Objetivo campanha:</strong>
                        &nbsp;
                        {details.OBJETIVO_CAMPANHA__c
                          ? details.OBJETIVO_CAMPANHA__c
                          : ' -'}
                      </p>
                    </div>
                    <div className="tw-text-start">
                      <p>
                        <strong>Descritivo campanha:</strong>
                        &nbsp;
                        {details.DESCRITIVO_CAMPANHA__c
                          ? details.DESCRITIVO_CAMPANHA__c
                          : ' -'}
                      </p>
                    </div>
                  </div>
                ) : (
                  <div className="tw-py-16 tw-flex tw-flex-col tw-h-full tw-items-center tw-justify-center">
                    <Spinner width={10} height={10} />
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="tw-mt-[1.5rem] tw-w-[100%] tw-bg-[#E3E3E3] tw-py-3 tw-rounded-md">
            <div className="tw-flex tw-flex-col tw-justify-between tw-items-start tw-px-3">
              <span className="tw-font-bold tw-my-2">
                Informações adicionais:
              </span>
              <textarea
                className={
                  !details.MENSAGEM__c
                    ? 'tw-text-gray-400 tw-w-[100%] tw-rounded-md'
                    : 'tw-bg-white tw-w-[100%] tw-rounded-md'
                }
                rows={3}
                readOnly
                value={details?.MENSAGEM__c || 'Nenhuma informação adicional.'}
                disabled={!details.MENSAGEM__c}
              ></textarea>
            </div>
          </div>

          <div className="">
            <div className="mb:tw-mt-[1.5rem]  sm:tw-mt-[1.5rem] tw-bg-[#E3E3E3] tw-rounded-md">
              <div className="tw-flex tw-text-start tw-gap-[7px]  mb:tw-flex-col sm:tw-flex-row sm:tw-justify-between sm:tw-items-center">
                {!loading && (
                  <>
                    <p className="tw-pl-3">
                      <strong>Corretora:</strong>
                      &nbsp;
                      {details.NOME_CORRETOR__c}
                    </p>
                    <p className="mb:tw-block sm:tw-hidden tw-pl-3">
                      <strong>EV:</strong>
                      &nbsp;
                      {details.ESTRUTURA_VENDA__c}
                    </p>
                    <p className="mb:tw-hidden sm:tw-block tw-font-bold tw-pl-[1vw] tw-bg-[#001E64] tw-pr-[1rem] tw-rounded-[0_0.4rem_0.4rem_0] tw-py-[0.7rem] tw-text-white">
                      EV:
                      {details.ESTRUTURA_VENDA__c}
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>
          {isManager && (
            <div className="mb:tw-mt-[1.5rem] sm:tw-mt-[1.5rem] tw-bg-[#E3E3E3] tw-rounded-md tw-px-5 tw-py-4">
              <h1 className="tw-font-bold">Encaminhamento de Lead</h1>
              <div className="mb:tw-mt-0 sm:tw-mt-4 tw-flex mb:tw-flex-col sm:tw-flex-row tw-gap-6 tw-items-center">
                <div className=" tw-flex mb:tw-flex-col sm:tw-flex-row mb:tw-items-center tw-gap-6 sm:tw-items-end">
                  <div>
                    <p className="tw-text-[0.875rem] tw-font-bold">
                      Responsável
                    </p>
                    <div className="tw-bg-white tw-flex tw-items-center tw-gap-1 tw-mt-1 tw-rounded-full tw-border tw-border-[#929292] tw-w-[16rem] tw-h-[1.86rem] tw-px-4">
                      <CustomIcon
                        src={idIcon}
                        width={14}
                        height={14}
                        color="white"
                      />
                      <input
                        placeholder="NOME DO RESPONSÁVEL"
                        value={searchSeller(details.LOGIN__c)}
                      />
                    </div>
                  </div>
                  <CustomIcon src={chevronRightIcon} />
                </div>
                <div className="mb:tw-flex-col sm:tw-flex-row tw-flex tw-gap-6 tw-items-end">
                  <div>
                    <p className="tw-text-[0.875rem] tw-font-bold">
                      Novo Responsável
                    </p>
                    <div className="tw-bg-white tw-flex tw-items-center tw-gap-1 tw-mt-1 tw-rounded-full tw-border tw-border-[#929292] tw-w-[16rem] tw-h-[1.86rem] tw-px-4">
                      <CustomIcon
                        src={idIcon}
                        width={14}
                        height={14}
                        color="white"
                      />
                      <select
                        className="tw-w-full"
                        style={{ outline: 'none' }}
                        disabled={
                          actualStatus === 'Concluido' &&
                          details.ABORDAGEM__c === true
                        }
                        onChange={(e) => {
                          const value = e.target.value.includes('-')
                            ? e.target.value
                            : null;
                          handleNovoVendedor(value);
                        }}
                      >
                        <option value="">SELECIONE NOVO RESPONSÁVEL</option>
                        {sellersList
                          ?.filter(
                            (item) =>
                              item?.nome !== searchSeller(details.LOGIN__c)
                          )
                          .map((item, index) => (
                            <option key={index} value={item?.id}>
                              {item?.nome}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div
                    className="tw-flex tw-items-center tw-gap-2"
                    style={{
                      visibility: changeSuccessful ? 'visible' : 'hidden'
                    }}
                  >
                    <CustomIcon src={checkIcon} />
                    <span className="tw-text-[0.875rem] tw-text-[#006217]">
                      Alteração realizada com sucesso!
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="mb:tw-block sm:tw-flex tw-justify-between">
            <div className="sm:tw-block tw-mt-[1.5rem] tw-min-h-[65vh] sm:tw-w-[49%] mb:tw-w-full tw-bg-[#E3E3E3] tw-rounded-md ">
              <div className="tw-flex tw-items-start tw-flex-col tw-w-[100%]">
                <div className="tw-bg-[#5A5A5A] tw-w-[100%] tw-rounded-t-md tw-p-4">
                  <p className="tw-text-white tw-font-bold tw-flex tw-items-center tw-gap-1">
                    <span>Alterar status do lead</span>
                    {state?.isGestor === true && (
                      <TooltipComponent tooltip="Você não tem permissão para alterar o status do lead. Apenas o vendedor responsável pelo lead pode realizar alterações.">
                        <span className="tw-cursor-pointer">
                          <IoMdInformationCircleOutline size={'1.2rem'} />
                        </span>
                      </TooltipComponent>
                    )}
                  </p>
                  <select
                    onChange={(e) => {
                      setValidateSave(true);
                      setNewStatus(e.target.value);
                    }}
                    disabled={
                      (actualStatus === 'Concluido' &&
                        details?.ABORDAGEM__c === true) ||
                      state?.isGestor === true
                    }
                    className="tw-w-full tw-p-2 tw-rounded-full tw-border-[#001E64] tw-border-solid tw-border-[1px]"
                  >
                    {!loading &&
                      showStatus().map((item, index) => {
                        return (
                          <option key={index} value={item.id}>
                            {item?.nome || ''}
                          </option>
                        );
                      })}
                  </select>
                </div>
                {newStatus !== 'Novas Oportunidades' &&
                  newStatus !== 'NovoContato' && (
                    <div className="tw-relative tw-flex tw-py-8 tw-px-4 tw-items-center tw-w-full">
                      <div className="tw-flex-grow tw-border-t tw-border-gray-500"></div>
                      <span className="tw-flex-shrink tw-mx-4 tw-border-gray-500">
                        <BsArrowDownCircle size={'2rem'} color="#FF5000" />
                      </span>
                      <div className="tw-flex-grow tw-border-t tw-border-gray-500"></div>
                    </div>
                  )}
                {newStatus === 'EmNegociacao' && (
                  <div className="tw-px-4">
                    <StatusDetailsNegociacao
                      info={emNegociacaoInfo}
                      validate={validateSave}
                      setValidate={setValidateSave}
                      setInfo={setEmNegociacaoInfo}
                    />
                  </div>
                )}
                {newStatus === 'Concluido' && (
                  <div className="tw-px-4 tw-w-[100%]">
                    <StatusDetailsConcluido
                      info={{ ...conclusionInfo, details }}
                      validate={validateSave}
                      setValidate={setValidateSave}
                      setInfo={setConclusionInfo}
                      actualStatus={actualStatus}
                    />
                  </div>
                )}
                {newStatus === 'NovoContato' && validateSave === false && (
                  <div className="tw-px-4 tw-mt-4 tw-text-[#AA2C23]">
                    <div className="tw-flex tw-items-center tw-gap-4 tw-w-[100%] tw-p-4 tw-bg-[#FACED2] tw-rounded-lg">
                      <IoIosInformationCircleOutline size={'3rem'} />
                      <p>
                        Por favor preencha os campos{' '}
                        <span className="tw-font-bold">
                          tentativas de agendamento
                        </span>{' '}
                        e{' '}
                        <span className="tw-font-bold">
                          agendar contato com lead (data/hora)
                        </span>{' '}
                        do novo agendamento.
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="tw-mt-[1.5rem] tw-flex tw-gap-4 tw-flex-col sm:tw-w-[49%] mb:tw-w-full  tw-rounded-md">
              {newStatus === 'NovoContato' && (
                <>
                  <div className="tw-flex tw-justify-start tw-items-start tw-flex-col tw-rounded-lg tw-p-4 tw-gap-4 tw-bg-[#E3E3E3] ">
                    <div>
                      <p className="tw-text-start tw-font-bold">
                        Tentativas de agendamento{' '}
                        <a className="tw-text-red-500 tw-font-bold">*</a>
                      </p>
                      {/* <p className="tw-text-red-500 tw-text-xs">
                        Preenchimento obrigatório
                      </p> */}
                    </div>

                    <select
                      onChange={(e) => {
                        setTentativas(e.target.value);
                      }}
                      value={tentativas || ''}
                      className={`tw-p-2 tw-rounded-full tw-w-[10rem] 64] tw-border-solid tw-border-[1px] ${
                        validateSave === true
                          ? ' tw-border-[#001E64] '
                          : ' tw-border-[#AA2C23] '
                      }`}
                    >
                      <option value={''}>Selecione</option>
                      <option value={'1'}>1ª Tentativa</option>
                      <option value={'2'}>2ª Tentativa</option>
                      <option value={'3'}>3ª Tentativa</option>
                      <option value={'4'}>4ª Tentativa</option>
                      <option value={'Outras'}>Outras</option>
                    </select>
                    {newStatus === 'NovoContato' && validateSave === false && (
                      <span className="tw-text-[#AA2C23] tw-text-[0.8rem]">
                        Por favor, preencha o campo tentativas de agendamento
                      </span>
                    )}
                    <div>
                      <p className="tw-text-start tw-font-bold">
                        Agendar contato com lead{' '}
                        <a className="tw-text-red-500 tw-font-bold">*</a>
                      </p>
                      {/* <p className="tw-text-red-500 tw-text-xs">
                        Preenchimento obrigatório
                      </p> */}
                    </div>
                    <div className=" sm:tw-block tw-w-[49%] tw-bg-[#E3E3E3] tw-rounded-md ">
                      <div className="tw-flex tw-gap-4 tw-items-center tw-w-[100%]">
                        <div className="tw-flex tw-relative">
                          <div>
                            <button
                              onClick={() => {
                                setOpenDatePicker(!openDatePicker);
                              }}
                              className={`tw-flex tw-gap-1 tw-items-center tw-px-3 tw-border-[0.1rem] tw-bg-white tw-text-[#001E64]  tw-p-2 tw-rounded-full tw-justify-between tw-w-[10rem] ${
                                validateSave === true
                                  ? ' tw-border-[#001E64]'
                                  : ' tw-border-[#AA2C23]'
                              }`}
                            >
                              <CiCalendar size={'1.2rem'} />

                              <span>
                                {startDate !== null
                                  ? format(new Date(startDate), 'dd/MM/yyyy')
                                  : '--/--/--'}
                              </span>
                            </button>
                            <DatePickerExport
                              time={time}
                              isMobile={mobileRef.current < 720}
                              setTime={setTime}
                              uniqueDate={true}
                              isOpen={openDatePicker}
                              setEndDate={setEndDate}
                              setStartDate={setStartDate}
                              setIsOpen={setOpenDatePicker}
                            />
                          </div>
                        </div>

                        <input
                          className="tw-flex tw-items-center tw-px-3 tw-bg-white tw-text-[#001E64] tw-p-2 tw-rounded-full tw-justify-between tw-w-[10rem] tw-border-[0.1rem] tw-border-[#001E64]"
                          value={time}
                          onChange={(e) => {
                            setTime(e.target.value);
                          }}
                          type={'time'}
                        />
                      </div>
                      {newStatus === 'NovoContato' && (
                        <span className="tw-text-[#AA2C23] tw-text-[0.8rem]">
                          {validateSave === false &&
                            'Por favor, preencha o campo agendar contato com lead'}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="tw-flex-col tw-gap-4 tw-bg-[#E3E3E3] tw-p-4 tw-rounded-lg">
                    <p className="tw-font-bold">Entrar em contato com leads</p>
                    <div className="tw-flex tw-gap-2 ">
                      {details.CELULAR__c && (
                        <button
                          className="tw-text-white tw-flex tw-gap-1 tw-items-center tw-h-fit tw-bg-[#1BD741] tw-px-[1rem] tw-py-[0.5rem] tw-rounded-md tw-cursor-pointer "
                          onClick={() => {
                            window.open(
                              `https://api.whatsapp.com/send?phone=55${formatCel(
                                details.CELULAR__c
                              )}`,
                              '_blank'
                            );
                          }}
                        >
                          <AiOutlineWhatsApp /> <span> Celular</span>
                        </button>
                      )}

                      {details.TELEFONE__c && (
                        <button
                          className="tw-text-white tw-flex tw-items-center tw-gap-1 tw-h-fit tw-bg-[#1BD741] tw-px-[1rem] tw-py-[0.5rem] tw-rounded-md tw-cursor-pointer "
                          onClick={() => {
                            window.open(
                              `https://api.whatsapp.com/send?phone=55${formatCel(
                                details.TELEFONE__c
                              )}`,
                              '_blank'
                            );
                          }}
                        >
                          <AiOutlineWhatsApp /> <span> Telefone</span>
                        </button>
                      )}
                      <a href={`mailto:${details.EMAIL__c}`}>
                        <div className="tw-text-white tw-flex tw-h-fit tw-gap-1 tw-items-center tw-bg-[#146CFA] tw-px-[1rem] tw-py-[0.5rem] tw-rounded-md">
                          <AiOutlineMail /> <span>Email</span>
                        </div>
                      </a>
                    </div>
                  </div>
                </>
              )}
              {newStatus === 'Novas Oportunidades' && (
                <div className="tw-flex-col tw-gap-4 tw-bg-[#E3E3E3] tw-p-4 tw-rounded-lg">
                  <p className="tw-font-bold">Entrar em contato com leads</p>
                  <div className="tw-flex tw-gap-2 ">
                    {details.CELULAR__c && (
                      <button
                        className="tw-text-white tw-flex tw-gap-1 tw-items-center tw-h-fit tw-bg-[#1BD741] tw-px-[1rem] tw-py-[0.5rem] tw-rounded-md tw-cursor-pointer "
                        onClick={() => {
                          window.open(
                            `https://api.whatsapp.com/send?phone=55${formatCel(
                              details.CELULAR__c
                            )}`,
                            '_blank'
                          );
                        }}
                      >
                        <AiOutlineWhatsApp /> <span> Celular</span>
                      </button>
                    )}

                    {details.TELEFONE__c && (
                      <button
                        className="tw-text-white tw-flex tw-items-center tw-gap-1 tw-h-fit tw-bg-[#1BD741] tw-px-[1rem] tw-py-[0.5rem] tw-rounded-md tw-cursor-pointer "
                        onClick={() => {
                          window.open(
                            `https://api.whatsapp.com/send?phone=55${formatCel(
                              details.TELEFONE__c
                            )}`,
                            '_blank'
                          );
                        }}
                      >
                        <AiOutlineWhatsApp /> <span> Telefone</span>
                      </button>
                    )}
                    <a href={`mailto:${details.EMAIL__c}`}>
                      <div className="tw-text-white tw-flex tw-h-fit tw-gap-1 tw-items-center tw-bg-[#146CFA] tw-px-[1rem] tw-py-[0.5rem] tw-rounded-md">
                        <AiOutlineMail /> <span>Email</span>
                      </div>
                    </a>
                  </div>
                </div>
              )}
              <div className="tw-flex tw-justify-start tw-items-start tw-flex-col tw-rounded-lg tw-p-4 tw-gap-4 tw-bg-[#E3E3E3] ">
                <p className="tw-text-start tw-font-bold">
                  Percepção do contato com lead
                </p>
                <div className="tw-flex tw-justify-between">
                  <div className="tw-flex tw-items-center tw-mb-4 md:tw-mr-2">
                    <input
                      onChange={(e) => setPercepcao(e.target.value)}
                      checked={percepcao === 'Quente'}
                      id="pme"
                      type="radio"
                      value="Quente"
                      name="proposta"
                      className="checked:tw-dark-blue checked:hover:tw-dark-blue checked:active:tw-dark-blue checked:focus:tw-dark-blue focus:tw-dark-blue focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-dark-blue"
                    />
                    <label
                      htmlFor="pme"
                      className="mb:tw-mx-1 sm:tw-ml-2 tw-text-sm tw-font-medium tw-text-gray-900"
                    >
                      Quente
                    </label>
                  </div>
                  <div className="tw-flex tw-items-center tw-mb-4 md:tw-mx-2">
                    <input
                      onChange={(e) => setPercepcao(e.target.value)}
                      id="pmeMais"
                      checked={percepcao === 'Morno'}
                      type="radio"
                      value="Morno"
                      name="proposta"
                      className="checked:tw-dark-blue checked:hover:tw-dark-blue checked:active:tw-dark-blue checked:focus:tw-dark-blue focus:tw-dark-blue focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-dark-blue"
                    />
                    <label
                      htmlFor="pmeMais"
                      className="mb:tw-mx-1 sm:tw-ml-2 tw-text-sm tw-font-medium tw-text-gray-900 "
                    >
                      Morno
                    </label>
                  </div>
                  <div className="tw-flex tw-items-center tw-mb-4 md:tw-mx-2">
                    <input
                      onChange={(e) => setPercepcao(e.target.value)}
                      checked={percepcao === 'Frio'}
                      id="empresarial"
                      type="radio"
                      value="Frio"
                      name="proposta"
                      className="checked:tw-dark-blue checked:hover:tw-dark-blue checked:active:tw-dark-blue checked:focus:tw-dark-blue focus:tw-dark-blue focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-dark-blue"
                    />
                    <label
                      htmlFor="empresarial"
                      className="mb:tw-mx-1 sm:tw-ml-2 tw-text-sm tw-font-medium tw-text-gray-900 "
                    >
                      Frio
                    </label>
                  </div>
                  <div className="tw-flex tw-items-center tw-mb-4 md:tw-mx-2">
                    <input
                      onChange={(e) => setPercepcao(e.target.value)}
                      checked={percepcao === 'Não tem interesse'}
                      id="vidaIndividual"
                      type="radio"
                      value="Não tem interesse"
                      name="proposta"
                      className="checked:tw-dark-blue checked:hover:tw-dark-blue checked:active:tw-dark-blue checked:focus:tw-dark-blue focus:tw-dark-blue focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-dark-blue"
                    />
                    <label
                      htmlFor="vidaIndividual"
                      className="mb:tw-mx-1 sm:tw-ml-2 tw-text-sm tw-font-medium tw-text-gray-900 "
                    >
                      Não tem interesse
                    </label>
                  </div>
                </div>
                <textarea
                  maxLength={500}
                  className="tw-border-[#D2D2D2] tw-border-solid tw-border-[1px] tw-min-h-[6rem] tw-resize-none tw-bg-white tw-w-[100%]"
                  value={anotacoes || ''}
                  onChange={(e) => {
                    setAnotacoes(e.target.value);
                  }}
                  placeholder="Anotações"
                />
                <p className=" tw-text-end tw-text-[0.8rem]">
                  {anotacoes?.length || 0}
                  /500
                </p>
              </div>
            </div>
          </div>
          <div>
            <div className="sm:tw-block tw-mt-[1.5rem] tw-bg-[#E3E3E3] tw-w-[100%] tw-rounded-2xl tw-px-[2vh] tw-py-[2vh]">
              <div className="tw-flex tw-flex-col tw-items-start tw-max-h-[30vh] tw-w-[100%] tw-overflow-y-auto tw-overflow-x-hidden">
                <p className="tw-font-bold tw-pr-[0.2vw]">Histórico:</p>
                <div className="tw-flex tw-items-center tw-w-[100%] tw-mb-[1rem] tw-flex-col">
                  {!historyLoading && history.length > 0 ? (
                    <div className="tw-w-[100%]">
                      <table className="tw-border-spacing-0 tw-w-[100%]">
                        <thead>
                          <tr>
                            <th></th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody className=" tw-w-[80vw]">
                          {history.map((item: any, index: any) => {
                            return (
                              <div key={index}>
                                <tr
                                  className={
                                    index % 2 === 0
                                      ? 'tw-w-[100%] tw-flex tw-items-center tw-justify-between'
                                      : 'tw-bg-[#efefef] tw-w-[100%] tw-flex tw-items-center tw-justify-between'
                                  }
                                  key={index}
                                >
                                  <td className="tw-pl-[0.5rem]">
                                    <span className="tw-font-bold">
                                      Motivo:
                                    </span>
                                    {setReasonHistory(item)}
                                  </td>
                                  <td className="">
                                    <div className="tw-flex tw-items-center tw-justify-end tw-py-[0.8rem] tw-pr-[1rem]">
                                      <AiOutlineClockCircle />
                                      <div className="tw-pl-[0.5rem]">
                                        {item.DATA_ULTIMA_ALTERACAO__c
                                          ?._seconds &&
                                          new Intl.DateTimeFormat('pt-BR', {
                                            timeZone: 'UTC'
                                          }).format(
                                            new Date(
                                              item.DATA_ULTIMA_ALTERACAO__c
                                                ?._seconds * 1000
                                            )
                                          )}
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              </div>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  ) : historyLoading ? (
                    <div></div>
                  ) : (
                    <div>
                      <p>Nenhum histórico para esse lead</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="tw-flex tw-justify-between tw-w-full tw-mt-4">
            <Link
              to={'/corretor/leads/kanban'}
              state={state?.vendedor ? { vendedor: state?.vendedor } : {}}
              className=" tw-inline-flex tw-text-[#001E64] tw-justify-center tw-h-[2.5rem] tw-bg-white tw-px-8 tw-py-2 tw-text-sm tw-font-semibold tw-border-[#001E64] tw-rounded-full tw-border-[0.1rem] sm:tw-w-auto "
              onClick={() => {
                state?.vendedor
                  ? setVisualizationState('gestao')
                  : setVisualizationState('card');
              }}
            >
              Voltar
            </Link>
            {loadingSaveDetails === false && state?.isGestor !== true && (
              <button
                type="button"
                onClick={() => {
                  saveLeadDetail();
                }}
                className={
                  'tw-inline-flex tw-w-[8rem] tw-justify-center tw-rounded-full  tw-bg-[#FA6B25] tw-px-8 tw-py-2 tw-text-sm tw-font-semibold tw-text-white tw-shadow-sm'
                }
              >
                Salvar
              </button>
            )}
            {loadingSaveDetails === true && (
              <button
                disabled
                className="tw-bg-[#FA6B25] tw-flex tw-items-center tw-justify-center  tw-text-[#EBEBEB] tw-font-bold tw-border-[0.1rem] tw-w-[10rem] tw-h-[2.5rem] tw-rounded-3xl"
              >
                <svg
                  className="tw-animate-spin tw-h-5 tw-w-5 tw-mr-3 "
                  viewBox="0 0 24 24"
                >
                  <path
                    xmlns="http://www.w3.org/2000/svg"
                    d="M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z"
                    className="spinner_P7sC"
                    fill="white"
                  />
                </svg>
                Processando...
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default LeadDetails;
